import {Component, ElementRef, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {WalletService} from "../wallet/wallet.service";
import {ToastrService} from "ngx-toastr";
import {AccountService} from "../account/account.service";
import {CryptoDepositService} from "./crypto-deposit.service";
import {AuthService} from "../../shared/services/auth.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-crypto-deposit',
  templateUrl: './crypto-deposit.component.html',
  styleUrls: ['./crypto-deposit.component.scss']
})
export class CryptoDepositComponent {
  cryptoDeposit = new FormGroup({
    symbol: new FormControl<string>('',Validators.required),
    wallet: new FormControl<string>('',Validators.required),
    value: new FormControl<number | null>(null,[Validators.required]),
    quote: new FormControl<number | null>(null,[Validators.required]),
    cryptoValue: new FormControl<number>(0),
    depositType: new FormControl<string>('', Validators.required),
    pixKey: new FormControl<string>('', Validators.required),
    holderName: new FormControl<string>('', Validators.required),
    bank: new FormControl<string>('', Validators.required),
    bankTransactionId: new FormControl<string>('', Validators.required),
    
  });

  public cryptos: any;
  public isInsert: boolean;
  public isSubmitted: boolean;
  public isLoaded: boolean;
  public isCopyPaste: boolean;
  public isPixKey: boolean;
  public symbols: any;
  public wallets: any;
  public pixKey: string;
  public saldoDisponivel: number = 0;
  public cryptoTaxValue: number = 0;
  public cryptoTaxPercent: number = 0;
  public placeholderValue: string;
  public price: number = 0;
  public valorTotal: number = 0;
  public errorMessage: string;
  public validationCode: string;
  public page: number = 1;
  public pageSize: number = 10;
  public total: number = 0;
  public qrCodeBase64: string
  public pixCopiaECola: string;
  public chavePixDeposito: string;
  public nomeTitular: string;
  public banco: string;
  public rampPrice: number = 0;
  public emConversao: number = 0;
  public emProcessamento: number = 0;
  public fileBase64: string = '';
  public fileName: string = '';
  public showPix: boolean = false;

  depositTypes = [
  { value: 'COPIA_COLA', label: 'Copia e Cola' },
  { value: 'CHAVE_PIX',  label: 'Chave Pix'   },
];

  @ViewChild('requestTOTPCode') validateToken : ElementRef | any;

  constructor(private walletService: WalletService,
              private accountService : AccountService,
              private cryptoDepositService: CryptoDepositService,
              private toastr: ToastrService,
              private authService: AuthService,
              private modalService: NgbModal)
  {
    this.isInsert = false;
    this.isSubmitted = false;
    this.isLoaded = false;
    this.isCopyPaste = false;
    this.isPixKey = false;
    this.getCryptoMoedaTransactions();
    this.getTotal();
    this.placeholderValue = '';
    this.errorMessage = '';
    this.validationCode = '';
    this.pixKey = '';
    this.qrCodeBase64 = '';
    this.pixCopiaECola = '';
    this.chavePixDeposito = '';
    this.nomeTitular = '';
    this.banco = ''
  }

  ngOnInit() {
    this.getAccountValues();
  }
  

  formatStatusClass(status: string): string {
    return 'status-' + status.toLowerCase().replace(/ /g, '-');
  }

  async pasteTotpCode(): Promise<void> {
    try {
      this.validationCode = (await navigator.clipboard.readText()).trim();
    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  getTotal(){
    this.cryptoDepositService.getamount().subscribe(
      value => {
        this.emConversao = value.amountConversao;
        this.emProcessamento = value.amountCrypto;
      }
    )
  }

  onFileSelected(event: any): void {
  const file: File = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    const base64 = (reader.result as string).split(',')[1];
    this.fileBase64 = base64;
    this.fileName = file.name;
  };
  reader.readAsDataURL(file);
}

  getCryptoMoedaTransactions(){
    this.isLoaded = false;
    this.cryptoDepositService.getCryptoTransactions(this.page, this.pageSize).subscribe(
      value => {
        this.cryptos = value[0].cryptotransaction;
        this.total = value[0].total;
        this.isLoaded = true;
      }
    );
  }

  pageChange(){
    this.getCryptoMoedaTransactions();
  }

  getAccountValues(){
    this.accountService.getAccount().then(
      value => {
        this.chavePixDeposito = value.pixKeyDepositDict;
        this.nomeTitular = value.nameDepositDict;
        this.banco = value.nameBankDepositDict;
      }
    );
  }
  

  getPlaceHolder(){
    let valorDisponivel = this.saldoDisponivel;
    let placeholderValue = (valorDisponivel - this.cryptoTaxValue) / (1 + (this.cryptoTaxPercent / 100));

    this.placeholderValue = Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(placeholderValue);
  }

  getPrice() {
  this.isLoaded = false;
  const valor = this.cryptoDeposit.controls.value.value;
  if(valor == null || valor == 0)
  {
    this.price = 0;
    this.isLoaded = true;
    return;
  }

  const symbolId = this.cryptoDeposit.controls.symbol.value;
  if(symbolId){
    const selectedSymbol = this.symbols.find((symbol: { id: any; }) => symbol.id === symbolId);
    if(selectedSymbol){
      const symbol = selectedSymbol.name;
      this.cryptoDepositService.getPriceBySymbol(symbol, symbolId, valor).subscribe(
        value => {
          this.price = value.data.quotePrice;
          this.cryptoDeposit.controls.cryptoValue.setValue(this.price);
          this.isLoaded = true;
        },(error) => {
          this.toastr.error(error.error.mensagem ,'Erro',{
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.isLoaded = true;
        })
    }
  }
}

  loadSymbols() {
    this.isLoaded = false;

      this.walletService.getSymbols().subscribe(symbols => {
        const origem = this.authService.getOriginCurrency();

        this.symbols = symbols.filter((s: any) => s.originCurrency === origem);

        this.isLoaded = true;
      });
  }

  loadWallets(){
    this.cryptoDeposit.controls.wallet.setValue('');
    this.isLoaded = false;
    let symbolId = this.cryptoDeposit.controls.symbol.value!;
    if(symbolId != ''){
      this.walletService.getEnabledWallets(symbolId).subscribe(
        value => {
          this.wallets = value;
          this.isLoaded = true
        }
      );
    }
  }

  async openWithdraw() {
    let validatePeriod = await this.validatePeriod();
    if(!validatePeriod){
      this.toastr.error('Transações de criptomoedas são permitidas apenas de segunda a sexta das 09:00 às 17:00','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.isLoaded = true;
      return;
    }

    this.isInsert = true;
    this.getAccountValues();
    this.loadSymbols();
    this.loadWallets();
    this.getPrice();
  }

  return() {
    this.isInsert = false;
    this.isCopyPaste = false;
    this.isPixKey = false;
    this.clearForm();
    this.getCryptoMoedaTransactions();
  }

  clearForm(){
    this.cryptoDeposit.controls.symbol.setValue('');
    this.cryptoDeposit.controls.wallet.setValue('');
    this.cryptoDeposit.controls.value.setValue(null);
    this.cryptoDeposit.controls.cryptoValue.setValue(0);

    this.cryptoDeposit.controls.symbol.setErrors(null);
    this.cryptoDeposit.controls.wallet.setErrors(null);
    this.cryptoDeposit.controls.value.setErrors(null);
    this.cryptoDeposit.controls.cryptoValue.setErrors(null);
    this.isSubmitted = false;
  }

  copyPixCode(): void { 
  if (!this.pixCopiaECola) {
    this.toastr.warning('Não há código PIX para copiar', 'Aviso', {
      timeOut: 2000,
      positionClass: 'toast-top-right'
    });
    return;
  }
  
  navigator.clipboard.writeText(this.pixCopiaECola).then(() => {
    this.toastr.success('Código PIX copiado com sucesso!', 'Sucesso', {
      timeOut: 2000,
      positionClass: 'toast-top-right'
    });
  }).catch(err => {
    this.toastr.error('Erro ao copiar código PIX', 'Erro', {
      timeOut: 2000,
      positionClass: 'toast-top-right'
    });
  });
}

  async nextStep() {
    this.isLoaded = false;
    this.isSubmitted = true;
    this.isCopyPaste = false;
    this.isPixKey = false;

    const tipo = this.cryptoDeposit.controls.depositType.value;

    if (tipo === 'COPIA_COLA') {
      const body = {
        typeOperation: 'PIX',
        symbolId: this.cryptoDeposit.controls.symbol.value,
        walletId: this.cryptoDeposit.controls.wallet.value,
        brlValue: this.cryptoDeposit.controls.value.value
      };

      try {
        const response: any = await lastValueFrom(this.cryptoDepositService.createCryptoDeposit(body));

        this.toastr.success(response.message || 'Depósito criado com sucesso!', 'Sucesso', {
          timeOut: 3000,
          positionClass: 'toast-top-right'
        });

        this.qrCodeBase64 = `data:image/png;base64,${response.qrCodeBase64}`;
        this.pixCopiaECola = response.pixCopiaECola;

        this.isPixKey    = false;
        this.isInsert    = true;
        this.isCopyPaste = true;

      } catch (error: any) {
        this.toastr.error(error?.error?.mensagem || 'Erro ao criar depósito', 'Erro', {
          timeOut: 3000,
          positionClass: 'toast-top-right'
        });
      }

      this.isLoaded = true;
      return;
    }

     if (tipo === 'CHAVE_PIX') {
      const valor = Number(this.cryptoDeposit.controls.value.value);
      
      if (valor > 0) {
        this.isPixKey = true;
        this.showPix = true;
      } else {
        this.toastr.warning('Preencha o valor antes de continuar.', 'Aviso', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        this.showPix = false;
      }

      this.isCopyPaste = false;
      this.isInsert = true;
      this.isLoaded = true;
    }
}

async confirmPixKeyDeposit() {
  const body = {
    typeOperation: 'ENDTOENDID',
    symbolId: this.cryptoDeposit.controls.symbol.value,
    walletId: this.cryptoDeposit.controls.wallet.value,
    brlValue: this.cryptoDeposit.controls.value.value,
    filePDF: {
      fileName: this.fileName,
      fileBase64: this.fileBase64
    }
  };

  try {
    this.isLoaded = false;
    await lastValueFrom(this.cryptoDepositService.createCryptoDeposit(body));
    this.toastr.success('Depósito criado com sucesso!', 'Sucesso', {
      timeOut: 3000,
      positionClass: 'toast-top-right'
    });
    this.return(); 
  } catch (error: any) {
    this.toastr.error(error?.error?.mensagem || 'Erro ao criar depósito', 'Erro', {
      timeOut: 3000,
      positionClass: 'toast-top-right'
    });
  }

  this.isLoaded = true;
}

  copy(): void { 
    if (!this.chavePixDeposito) {
      this.toastr.warning('Não há chave Pix para copiar', 'Aviso', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
      return;
    }
    navigator.clipboard.writeText(this.chavePixDeposito).then(() => {
      this.toastr.success('Chave Pix copiada com sucesso!', 'Sucesso', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    }).catch(err => {
      this.toastr.error('Erro ao copiar Chave Pix', 'Erro', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    });
  }

  async paste(): Promise<void> {
    try {
      const text = await navigator.clipboard.readText();

      this.cryptoDeposit.controls.bankTransactionId.setValue(text.trim());

    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  withdraw() {
    this.isLoaded = false;
    this.isSubmitted = true;

    if(this.authService.isReadOnly()){
      this.toastr.error('Seu usuário não tem permissão para realizar essa operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    if(this.cryptoDeposit.valid && this.valorTotal > this.saldoDisponivel){
      this.toastr.error('Valor excede o saldo + taxas administrativas','Erro',
      {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.isLoaded = true;
      return;
    }

    if(this.cryptoDeposit.valid)
    {
      this.modalService.open(this.validateToken, {backdrop: "static", keyboard: false, centered: true, size: 'sm'});
    }

    this.isLoaded = true;
  }

  async validatePeriod(): Promise<boolean>
  {

    let accountValidatePeriod = true;
    await lastValueFrom(this.cryptoDepositService.canMakeCryptoTransactionWithoutHour()).then(value =>
      {
        accountValidatePeriod = value
      });

    if(!accountValidatePeriod){
      return true;
    }

    let now = new Date();
    let diaSemana = new Intl.DateTimeFormat('pt-BR', {weekday: 'long'}).format(now);
    let hora = new Intl.DateTimeFormat('pt-BR', {hour: "numeric", hour12: false}).format(now);

    let diaDaSemana = (diaSemana !== 'domingo' && diaSemana !== 'sábado');
    let horaValida = parseInt(hora) >= 9 && parseInt(hora) < 17;

    return diaDaSemana && horaValida;
  }

 valorChanged() {
  const valorFiat = Number(this.cryptoDeposit.controls.value.value);

  if (valorFiat > 0) {
    this.isLoaded = false;
    this.cryptoDepositService.getRampPrice()
      .subscribe({
        next: res => {
          const cotacao = res?.price ?? 0;
          this.rampPrice = cotacao;
          this.cryptoDeposit.controls.quote.setValue(cotacao);

          const cryptoValue = valorFiat / cotacao;
          this.cryptoDeposit.controls.cryptoValue.setValue(Number(cryptoValue.toFixed(4)));

          this.isLoaded = true;
        },
        error: err => {
          this.toastr.error('Erro ao buscar cotação', 'Erro', {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          });
          this.isLoaded = true;
        }
      });
  } else {
    this.cryptoDeposit.controls.cryptoValue.setValue(0);
    this.cryptoDeposit.controls.quote.setValue(null);
  }
}

copyTxid(txid: string): void {
    navigator.clipboard.writeText(txid).then(() => {
      this.toastr.success('TxID copiado com sucesso!', 'Success', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    }).catch(err => {
      this.toastr.error('Erro ao copiar TxID', 'Error', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    });
  }

  async validateTotp() {
    if(await this.isValidTotp()){
      this.isLoaded = false
      this.modalService.dismissAll();
      let transaction = {
        symbolId : this.cryptoDeposit.controls.symbol.value,
        walletId: this.cryptoDeposit.controls.wallet.value,
        brlValue: this.cryptoDeposit.controls.value.value,
      }
      lastValueFrom(this.cryptoDepositService.addCryptoTransaction(transaction))
      .then(value => {
        this.toastr.warning(value.message,'Sucesso',{
          timeOut: 3000,
          positionClass: 'toast-center-center',
        });
        this.clearForm();
        this.isLoaded = true;
        this.isSubmitted = false;
      }, (error) => {
        this.toastr.error(error.error.mensagem ,'Erro',{
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        this.isLoaded = true;
      })
    }else{
      this.errorMessage = 'Código de autenticação inválido!';
    }
  }

  async isValidTotp()
  {
    let isValid: boolean = false;
    await this.authService.validateTotpCode(this.validationCode).then(
      value => {
        isValid = value.isValid;
      }
    );
    return isValid;
  }

  

}
